




























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({
  name: "ui-tree-element"
})
export default class UiTreeElementComponent extends Vue {
  @Prop({  })                     item: ListVievItem<any>;
  @Prop({ default: false })     isOpen: boolean;
  @Prop({ default: false })   selected: boolean;
  @Prop({ default: true })   root: boolean;
  innerSelected = this.selected;
  innerIsOpen = this.isOpen;
  
   
  @Watch("isOpen")
  isOpenChange(){
    this.innerIsOpen = this.isOpen;
  }
  clickNode() {
    this.innerIsOpen = !this.innerIsOpen;
  }
  select(value:any, event: string){
    this.$emit("select",value)
  }
  onShowContextMenu(ev: MouseEvent, value: number) {
    this.$emit("contextMenu", ev, value);
  }
  clickHeader() {
    this.innerSelected = !this.innerSelected;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-tree/src/ui-tree-element.vue